import { t } from "@redotech/redo-i18n";
import { assertNever } from "@redotech/util/type";

export enum NotificationTab {
  GENERAL = "general",
  RETURNS_CLAIMS = "returns-claims",
  WARRANTIES = "warranties",
  SUPPORT = "support",
  ORDER_TRACKING = "order-tracking",
  OUTBOUND_LABELS = "outbound-labels",
  INVENTORY_MANAGEMENT = "inventory-management",
}

export function notificationTabToFriendly(tab: NotificationTab): string {
  switch (tab) {
    case NotificationTab.GENERAL:
      return t("General");
    case NotificationTab.RETURNS_CLAIMS:
      return t("Returns & claims");
    case NotificationTab.WARRANTIES:
      return t("Warranties");
    case NotificationTab.SUPPORT:
      return t("Support");
    case NotificationTab.ORDER_TRACKING:
      return t("Order tracking");
    case NotificationTab.OUTBOUND_LABELS:
      return t("Outbound labels");
    case NotificationTab.INVENTORY_MANAGEMENT:
      return t("Inventory management");
    default:
      return assertNever(tab);
  }
}
